// Pure date helpers for the patient activity feed.
//
// No Vue, no axios — just the timezone rules, so they stay deterministic and
// testable. Activity rows carry either a real datetime (a UTC instant, e.g. a
// note's Created) or a date-only value (a SQL DATE column with no time or zone,
// e.g. a prescription's WrittenDate, flagged by `isDateOnly`).

import moment from 'moment'

/**
 * Build the moment used to display an activity row.
 *
 * Datetime rows are UTC instants → convert to the viewer's local timezone.
 * Date-only rows have no time or zone, so a UTC→local conversion would subtract a
 * day in UTC-negative timezones; parse them in the LOCAL frame instead so the
 * calendar day the value names is the calendar day shown.
 */
export function activityMoment(timestamp: string, isDateOnly: boolean): moment.Moment {
    return isDateOnly ? moment(timestamp) : moment.utc(timestamp).local()
}

/**
 * Full date/time label for a row (used in the hover tooltip). Date-only rows omit
 * the time — they don't have one, so showing "12:00 AM" would be misleading.
 */
export function formatActivityFullDate(timestamp: string, isDateOnly: boolean): string {
    const m = activityMoment(timestamp, isDateOnly)
    return isDateOnly ? m.format('MMMM D, YYYY') : m.format('MMMM D, YYYY h:mm A')
}
